module.exports = "<button mat-button class=\"logout-btn\" (click)=\"logout()\">Logout</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/logout/logout.component.html
// module id = ./src/app/header/logout/logout.component.html
// module chunks = main